import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { GET_ALL_DIVISION } from "../../../api-setup/api-endpoints";

export const fetchDivisionData = async (cookiesData, dispatch) => {
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_filter: "",
      in_sort_number: 1,
      in_sort_order: "ASC",
      in_page_row_offset: 0,
      in_page_rows: null,
    };

    const response = await POSTAPI(false, GET_ALL_DIVISION, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      const rawData = response.data.row_result;

      const transformedData = rawData.map((division) => ({
        id: division.division_mstr_key,
        text: division.name,
      }));

      return {
        success: true,
        divisionData: rawData,
        transformedData: transformedData,
        count: transformedData.length,
      };
    } else {
      console.error("Failed to fetch division data:", response?.message || "Invalid response structure");
      return {
        success: false,
        divisionData: [],
        transformedData: [],
        count: 0,
        error: response?.message || "Invalid response structure",
      };
    }
  } catch (error) {
    console.error("Error fetching division data:", error);
    return {
      success: false,
      divisionData: [],
      transformedData: [],
      count: 0,
      error: error.message,
    };
  }
};
